import ReactMarkdown from 'react-markdown'
import CodeBlock from './CodeBlock'
import MermaidBlock from './MermaidBlock'
import Logo from '../Logo'

function CodeRenderer({ className, children }) {
  const isBlock = /language-/.test(className || '')
  if (!isBlock) {
    return (
      <code className="bg-zinc-800 px-1 rounded text-emerald-400 text-xs font-mono">
        {children}
      </code>
    )
  }
  const lang = (className || '').replace('language-', '')
  if (lang === 'mermaid') return <MermaidBlock>{String(children)}</MermaidBlock>
  return <CodeBlock className={className}>{String(children)}</CodeBlock>
}

const components = {
  code: CodeRenderer,
  a({ href, children }) {
    const isExternal = href?.startsWith('http')
    return (
      <a
        href={href}
        target={isExternal ? '_blank' : undefined}
        rel={isExternal ? 'noopener noreferrer' : undefined}
        className="text-emerald-400 underline hover:text-emerald-300"
      >
        {children}
      </a>
    )
  },
  h1({ children }) {
    return <h1 className="text-2xl font-mono font-bold text-zinc-100 mt-8 mb-4 border-b border-zinc-800 pb-2">{children}</h1>
  },
  h2({ children }) {
    return <h2 className="text-xl font-mono font-semibold text-zinc-200 mt-6 mb-3">{children}</h2>
  },
  h3({ children }) {
    return <h3 className="text-base font-mono font-semibold text-zinc-300 mt-4 mb-2">{children}</h3>
  },
  table({ children }) {
    return (
      <div className="overflow-x-auto my-4">
        <table className="border-collapse w-full text-sm font-mono">{children}</table>
      </div>
    )
  },
  th({ children }) {
    return (
      <th className="border border-zinc-700 px-3 py-1.5 text-left text-xs font-semibold text-zinc-300 bg-zinc-800">
        {children}
      </th>
    )
  },
  td({ children }) {
    return (
      <td className="border border-zinc-700 px-3 py-1.5 text-zinc-400">
        {children}
      </td>
    )
  },
  img: ({ src, alt }) => {
    if (src === '/logo.svg') {
      return <div className="flex justify-center my-10"><Logo variant="full" size={380} transparent /></div>
    }
    return <img src={src} alt={alt} className="mx-auto block max-w-sm h-auto my-8" />
  },
}

export default function DocContent({ content }) {
  return (
    <div className="font-mono text-sm text-zinc-300 leading-relaxed">
      <ReactMarkdown components={components}>{content}</ReactMarkdown>
    </div>
  )
}
